export default function resolveUserSteamId(user) {
  if (!user || typeof user !== "object") {
    return null;
  }

  const candidates = [user.steamId, user.steamId64, user.steam64Id];

  for (const candidate of candidates) {
    if (candidate === null || candidate === undefined) {
      continue;
    }

    const normalized = String(candidate).trim();
    if (normalized) {
      return normalized;
    }
  }

  return null;
}
